/** @jsx jsx */
import { Box } from '@bottlebooks/gatsby-theme-base';
import { jsx, ThemeProvider } from 'theme-ui';
import BaseLayout from './BaseLayout';
import useEventTheme from './useEventTheme';

export default function PreviewLayout({ children, locale, ...rest }) {
  const eventTheme = useEventTheme();
  return (
    <ThemeProvider theme={eventTheme}>
      <BaseLayout {...rest}>
        <Box as="main">{children}</Box>
      </BaseLayout>
    </ThemeProvider>
  );
}
